import { connect } from 'react-redux'
import at from 'lodash/at'
import throttle from 'lodash/throttle'

import { loadLocations, searchLocations } from '../../actions/locations'

import WorkTrackersList from '../../components/work-trackers/work-trackers-list'

function mapStateToProps (state, ownProps) {
  const locations = at(state.locations, state.pagination.locations.ids || [])

  return {
    locations,
    hasNextPage: state.pagination.locations.nextPageUrl
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  dispatch(searchLocations(''))
  let searchQuery = ''

  const loadFirstPageThrottled = throttle(
    () => {
      if (searchQuery.length !== 0 && searchQuery.length < 2) return
      dispatch(searchLocations(searchQuery))
    }, 250
  )

  return {
    onLoadNextPage () {
      dispatch(loadLocations(true))
    },
    onSearchLocations (search) {
      searchQuery = search
      loadFirstPageThrottled()
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkTrackersList)



// WEBPACK FOOTER //
// ./src/containers/work-trackers/work-trackers-container.js